var script = document.createElement('script');

    // Set the source attribute to the jQuery library URL
    script.src = 'https://code.jquery.com/jquery-3.6.4.min.js';

    // Append the script element to the head of the document
    document.head.appendChild(script);

    // You can also use the onload event to perform actions once jQuery is loaded
    script.onload = function() {
        console.log('jQuery has been loaded!');
        // Your jQuery-dependent code can go here



var ur = window.location.href;




(function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));
 
 setTimeout(function(){ 

setInterval(function(){
if(jQuery('span.myisense-slide-easy').length == 0 && jQuery('button.checkout-button').length){
  Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};

var container = document.createElement('span');
container.className = 'myisense-slide-easy';
container.innerHTML = "Easy Returns: No Return Fees, No Hassles, No Risks & Absolutely No Gimmicks.";
var y = document.querySelectorAll('button.checkout-button')[0];
if(document.getElementsByClassName('myisense-slide-easy').length == 0){
  // container.appendAfter(y);  
  
}
}
  }, 50);

jQuery(document).ready(function(){
 jQuery('h3.heading.h5').eq(0).after(jQuery('#reviews-badges-page > a').eq(0));
  jQuery('h3.heading.h5').eq(1).after(jQuery('#reviews-badges-page > a').eq(0));
  var jjjr = 0; var timerjjjr = setInterval(function(){
  if(jQuery('.junip-product-summary-review-count').length) {
	var rev = jQuery('.junip-product-summary-review-count').eq(0).html();
if (typeof rev === 'string') {
  rev = rev.replace('(', '').replace(')', ' Reviews from Happy Customers');
}
    jQuery('.junip-product-summary-review-count').eq(0).html(rev);
    var rev = jQuery('.junip-product-summary-review-count').eq(1).html();
if (typeof rev === 'string') {
  rev = rev.replace('(', '').replace(')', ' Reviews from Happy Customers');
}
jQuery('.junip-product-summary-review-count').eq(1).html(rev);
}if( jjjr > 200){clearInterval(timerjjjr);}jjjr++;}, 50);
});


var ur = window.location.href;
if((ur.includes('isense-hybrid-premier') || ur.includes('isense-classic') )&& jQuery('.myisense-customer-report').length == 0){
jQuery(document).ready(function(){
 
jQuery('.shopify-section--product-content').after(jQuery(`<div class="myisense-customer-report" id="shopify-section-template--17231818588474__8dcc4339-8b19-4281-a201-b4b530f94527" class="shopify-section shopify-section--multi-column"><style>
  #shopify-section-template--17231818588474__8dcc4339-8b19-4281-a201-b4b530f94527 {--heading-color: 16, 28, 73;
    --text-color: 40, 40, 40;
    --prev-next-button-background: 255, 255, 255;
    --prev-next-button-color: 40, 40, 40;
    --section-background: 238, 244, 245;
  }</style>
<section class="section section--flush">
  <div class="section__color-wrapper">
    <div class="container vertical-breather"><header class="section__header section__header--tight section__header--center">
          <div class="text-container"><h3 class="heading h2">87% of customers reported better sleep on their iSense mattress*</h3><p><em>* Based on a random survey of 200 iSense customers conducted October - December 2022. Respondents slept on an iSense mattress for at least 6 months.</em></p></div>
        </header><multi-column stack="" stagger-apparition="" class="multi-column multi-column--pocket-medium multi-column--medium multi-column--spacing-normal became-visible" style="opacity: 1;"><div>
            <scrollable-content class="multi-column__inner multi-column__inner--center "><div id="block-template--17231818588474__8dcc4339-8b19-4281-a201-b4b530f94527-template--14875806367804__8dcc4339-8b19-4281-a201-b4b530f94527-166785438869fef298-0" class="multi-column__item multi-column__item--align-start " reveal="" style="opacity: 1;"><div class="multi-column__image-wrapper" style="max-width: 28%; width: 131px">
                        <img loading="lazy" sizes="(max-width: 740px) calc(100vw - 48px), (max-width: 999px) calc(25vw - 80px), 272px" class="multi-column__image" height="154" width="131" alt="" src="//cdn.shopify.com/s/files/1/0081/5723/3216/files/ThumbsUp_131x.png?v=1667849270" srcset="//cdn.shopify.com/s/files/1/0081/5723/3216/files/ThumbsUp_131x.png?v=1667849270 131w">
                      </div><div class="multi-column__text-container text--center text-container"><h3 class="heading h5">4 out of 5</h3><p>4 out of 5 iSense customers would recommend to their friends and family.*</p></div></div><div id="block-template--17231818588474__8dcc4339-8b19-4281-a201-b4b530f94527-template--14875806367804__8dcc4339-8b19-4281-a201-b4b530f94527-166785438869fef298-1" class="multi-column__item multi-column__item--align-start " reveal="" style="opacity: 1;"><div class="multi-column__image-wrapper" style="max-width: 36%; width: 167px">
                        <img loading="lazy" sizes="(max-width: 740px) calc(100vw - 48px), (max-width: 999px) calc(25vw - 80px), 272px" class="multi-column__image" height="146" width="167" alt="" src="//cdn.shopify.com/s/files/1/0081/5723/3216/files/Flower_167x.png?v=1667849455" srcset="//cdn.shopify.com/s/files/1/0081/5723/3216/files/Flower_167x.png?v=1667849455 167w">
                      </div><div class="multi-column__text-container text--center text-container"><h3 class="heading h5">82%</h3><p>82% of customers said their iSense mattress helped reduce overall aches, stiffness, soreness, and/or discomfort.*</p></div></div><div id="block-template--17231818588474__8dcc4339-8b19-4281-a201-b4b530f94527-template--14875806367804__8dcc4339-8b19-4281-a201-b4b530f94527-166785438869fef298-2" class="multi-column__item multi-column__item--align-start " reveal="" style="opacity: 1;"><div class="multi-column__image-wrapper" style="max-width: 43%; width: 212px">
                        <img loading="lazy" sizes="(max-width: 740px) calc(100vw - 48px), (max-width: 999px) calc(25vw - 80px), 272px" class="multi-column__image" height="157" width="212" alt="" src="//cdn.shopify.com/s/files/1/0081/5723/3216/files/SpineAlignment_212x.png?v=1667849736" srcset="//cdn.shopify.com/s/files/1/0081/5723/3216/files/SpineAlignment_200x.png?v=1667849736 200w, //cdn.shopify.com/s/files/1/0081/5723/3216/files/SpineAlignment_212x.png?v=1667849736 212w">
                      </div><div class="multi-column__text-container text--center text-container"><h3 class="heading h5">70%</h3><p>70% of back pain sufferers said their iSense mattress helped some or a lot*</p></div></div></scrollable-content></div>
        </multi-column></div>
  </div>
</section>
</div>`));
  
});
}

}, 1000);



/* Redesign Form 11/20 */

jQuery(document).ready(function() {
console.log('start')
// Check if .atc-container already exists on the page
const atcContainer = document.querySelector('.atc-container');
if (!atcContainer) {
  // Create a new div element
  const newDiv = document.createElement('div');
  newDiv.className = 'atc-container'; // Set the class name for the new div
  // Find the element with the class "block-swatch-list"
 const variantWrapper = document.querySelector('.product-form__variants');
const productForm = document.querySelector('.product-form')
if (variantWrapper) {
  // Insert the new div AFTER the entire variants wrapper
  variantWrapper.insertAdjacentElement('afterend', newDiv);
} else if (productForm) {
    productForm.append(newDiv)
  } else {
    // If .block-swatch-list doesn't exist, you can append it to the body
    document.body.appendChild(newDiv);
  }
}
 
// debugger;
if(jQuery('.atc-container button#AddToCart').length < 1)
{

jQuery('.shopify-section--main-product .atc-container')
            .append(jQuery('.shopify-section--main-product .chat-banner-wrapper'))
            .append(jQuery('.shopify-section--main-product .product-form__buy-buttons'))
            .append(jQuery('.shopify-section--main-product .product-form__custom-liquid').eq(0))
            .append(jQuery('.shopify-section--main-product .affirm-as-low-as')); 
jQuery('.free_shipping').prepend('<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"> <g clip-path="url(#clip0_3_414)"> <path d="M24.4999 15.75L25.3749 14H19.2499L19.9499 12.25H25.6666L26.5416 10.5H17.4416L18.1416 8.74996H26.7049L27.7083 6.99996H23.3333C23.3333 6.38112 23.0874 5.78763 22.6498 5.35004C22.2122 4.91246 21.6188 4.66663 20.9999 4.66663H6.99992V9.33329H3.49992L-8.39233e-05 14V19.8333H2.33325C2.33325 20.7615 2.702 21.6518 3.35838 22.3082C4.01475 22.9645 4.90499 23.3333 5.83325 23.3333C6.76151 23.3333 7.65175 22.9645 8.30812 22.3082C8.9645 21.6518 9.33325 20.7615 9.33325 19.8333H13.9999C13.9999 20.7615 14.3687 21.6518 15.025 22.3082C15.6814 22.9645 16.5717 23.3333 17.4999 23.3333C18.4282 23.3333 19.3184 22.9645 19.9748 22.3082C20.6312 21.6518 20.9999 20.7615 20.9999 19.8333H23.3333V15.75H24.4999ZM5.83325 21.5833C5.36912 21.5833 4.924 21.3989 4.59581 21.0707C4.26763 20.7425 4.08325 20.2974 4.08325 19.8333C4.08325 19.3692 4.26763 18.924 4.59581 18.5959C4.924 18.2677 5.36912 18.0833 5.83325 18.0833C6.29738 18.0833 6.7425 18.2677 7.07069 18.5959C7.39887 18.924 7.58325 19.3692 7.58325 19.8333C7.58325 20.2974 7.39887 20.7425 7.07069 21.0707C6.7425 21.3989 6.29738 21.5833 5.83325 21.5833ZM4.08325 11.0833H6.99992V14H1.79659L4.08325 11.0833ZM17.4999 21.5833C17.0358 21.5833 16.5907 21.3989 16.2625 21.0707C15.9343 20.7425 15.7499 20.2974 15.7499 19.8333C15.7499 19.3692 15.9343 18.924 16.2625 18.5959C16.5907 18.2677 17.0358 18.0833 17.4999 18.0833C17.964 18.0833 18.4092 18.2677 18.7374 18.5959C19.0655 18.924 19.2499 19.3692 19.2499 19.8333C19.2499 20.2974 19.0655 20.7425 18.7374 21.0707C18.4092 21.3989 17.964 21.5833 17.4999 21.5833Z" fill="#2F6F83"></path> </g> <defs> <clipPath id="clip0_3_414"> <rect width="28" height="28" fill="white" transform="matrix(-1 0 0 1 28 0)"></rect> </clipPath> </defs></svg>') 
jQuery('.shopify-section--main-product .product-form').after(jQuery('.shopify-section--main-product .product-form__contact'))
jQuery('.shopify-section--main-product .product-form').after(jQuery('.shopify-section--main-product .product-form__custom-liquid').eq(1)) 
 jQuery('.shopify-section--main-product .product-form').prepend(jQuery('.shopify-section--main-product .product-meta.product-meta'))
 
// if(jQuery('.atc-container product-meta.product-meta').length == 0 && jQuery('.shopify-section--main-product product-meta.product-meta').length == 1) {
// 	jQuery('.atc-container').prepend(jQuery('.shopify-section--main-product product-meta.product-meta').clone());
// 		jQuery('.atc-container .price-list').after(jQuery('.shopify-section--main-product .product-form .price-list').eq(0))
//   	console.log('cloned')
// }
if(jQuery('.atc-container .product-meta__price-list-container').length == 0){
	jQuery('.atc-container').prepend(jQuery('.shopify-section--main-product .product-meta__price-list-container'))
}
console.log('append executed')
}
const doublePriceFixProductTemplates = [
  'chillflex-pillow',
  'elite-base',
  'essential-base',
  'breeze-platform-base',
  'sheet-set',
  'mattress-protector',
  'classic-pillow',
  'cooling-protector',
  'bedjet-3',
  'bedjet-3-dual-zone',
  'cloud-sheet'
]
const shouldFixDoublePrice = doublePriceFixProductTemplates.reduce((previousValue, currentValue) => {
  return previousValue || jQuery('body').hasClass(`template--product-${currentValue}`)
}, false);
if (shouldFixDoublePrice){
	console.log('detected')
        jQuery('.shopify-section--main-product .price-list:nth-child(2)').css('display','none')
		jQuery('.shopify-section--main-product .atc-container').before(jQuery('.shopify-section--main-product .product-form__quantity'))
		
if (jQuery('.shopify-section--main-product product-meta.product-meta .junip-product-summary-stars-wrapper').length == 0) {
  jQuery('.shopify-section--main-product product-meta.product-meta').eq(0).append(jQuery('.junip-product-summary-stars-wrapper').eq(0))
	console.log('move executed')
}
}

setInterval(function(){
if (jQuery('.atc-container .label-list').length) {
  // jQuery('.shopify-section--main-product .product-meta__price-list-container').css({
  //   'flex-direction': 'row-reverse',
  //   // 'justify-content': 'flex-start',
  // });
jQuery('.shopify-section--main-product .atc-container .price--highlight span.money').css({
    // 'margin-right': '10px',
    'justify-content': 'flex-start',
  });
	
  jQuery('.shopify-section--main-product .label--highlight').css({
    'background': '#fff',
    'border-radius': '5px',
    'border': '1px solid #F68D2C',
    'color': '#F68D2C',
    'text-align': 'center',
    'font-size': '14px',
    'font-weight': '400',
  });
  jQuery('.shopify-section--main-product .label-list').css({
    'margin-left': '0',
    'margin-right': '10px',
  });
  jQuery('.shopify-section--main-product .price-list').css({
    // 'flex-direction': 'row-reverse',
  });
  jQuery('.shopify-section--main-product .product-meta__price-list-container .price--highlight').css({
    // 'margin-left': '10px',
    'margin-right': '0!important',
  });
// console.log('added css')
}

  }, 500);


if(window.innerWidth < 1000) {
 jQuery('.shopify-section--main-product .product-form').prepend(jQuery('.shopify-section--main-product .show-tablet-down').prepend(jQuery('.shopify-section--main-product .product-meta__title')))
 jQuery('.shopify-section--main-product .product-form').after(jQuery('.shopify-section--main-product .guarantee_wrapper'))

  jQuery('.memorial-special-wrapper').insertBefore('.product-meta__title.1')
jQuery('.shopify-section--main-product .junip-product-summary-stars-wrapper').css({
    'margin-top': '10px',
    'margin-bottom': '-20px',
  });
}
console.log('end')                     
});

/* END Redesign Form 11/20 */

    };